import { Link, Pagination, DVString, WatchlistAction } from './shared';
import { WatchlistItem } from './watchlist'
import { LibraryItem } from './library'
import { CustomerReviews, Infobox, MaturityRatingProps } from './hover'
import { MyStuffItemPlaybackAction } from './mystuff'

export enum ListWPSTypes {
    ListItems = 'atv.wps#ListItems',
    ListMessage = 'atv.wps#ListMessage'
}

export interface ListFilter extends Link {
    id: string;
    applied?: boolean;
}

export interface ListSortOption extends Link {
    id: string;
    applied?: boolean;
}

export interface ListSorter {
    label: string;
    appliedText: string;
    options: ListSortOption[];
}

export interface ListTabHeader extends Link {
    applied?: boolean;
}

export interface Breadcrumb {
    parents: Link[];
    current: string;
}

export enum ListContentTypeRequest {
    TV = 'TV',
    MOVIE = 'MOVIE',
    TV_ELSE_MOVIE = 'TV_ELSE_MOVIE',
    MOVIE_ELSE_TV = 'MOVIE_ELSE_TV',
    ALL = 'ALL'
}

export enum ListSort {
    DATE_ADDED_DESC = 'DATE_ADDED_DESC',
    TITLE_ASC = 'TITLE_ASC',
    TITLE_DESC = 'TITLE_DESC'
}

export enum ListItemsContentType {
    TV = 'TV',
    MOVIE = 'MOVIE',
    ALL = 'ALL'
}

export enum LiveEventStateType {
    LIVE = 'LIVE',
    DISRUPTED = 'DISRUPTED',
    OTHER = 'OTHER'
}

export interface ListItem {
    titleID: string;
    title: string;
    href: string;
    imageSrc: string;
    titleMessage?: string;
    titleActions?: {
        [key: string]: Link;
    },
    liveEvent?: LiveEventData,
    synopsis?: string,
    releaseYear?: number,
    maturityRating?: ListItemMaturityRatingModel,
    contentMaturityRating?: MaturityRatingProps,
    runTime?: string,
    hasSubtitles: boolean,
    imdbRating?: string,
    watchlistAction?: WatchlistAction,
    playbackAction?: MyStuffItemPlaybackAction,
    isNewHover: boolean,
    offers?: DVString[],
    infoboxes?: Infobox[],
    customerReviews?: CustomerReviews
}

export interface ListItemMaturityRatingModel {
    rating: string,
    description?: string
}

export interface LiveEventData {
    liveStateType: LiveEventStateType;
    message?: string;
    dateTime?: string;
}

export type ListItemType = WatchlistItem | LibraryItem

export interface ListContent {}

export interface ListItems extends ListContent {
    items: ListItemType[];
    message?: DVString;
    totalItems: number;
    seeMoreHref?: string;
    nextPageStartIndex?: number;
    contentType: ListItemsContentType;
    pagination?: Pagination;
    __type: ListWPSTypes.ListItems;
}
export interface ListMessage extends ListContent {
    title: string;
    message: DVString;
    icon?: string;
    __type: ListWPSTypes.ListMessage;
}

export type ListContentType = ListItems | ListMessage